import { FlexBox, Logo } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { SideDrawer } from './side_drawer'
import { useMotionValueEvent, useScroll } from 'framer-motion'
import { useState } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { MLPHeaderLinks } from './MLPHeaderLinks'
import { MLPDownloadAppCTA } from '../MLPDownloadAppCTA'
import { MLPHeaderLink } from '../types'
import { getHeaderLinks } from '../utils'

interface Props {
  links?: MLPHeaderLink[]
  swap?: boolean
}

export const MLPHeader = ({ links, swap = false }: Props) => {
  const { colors, mediaQueries } = useTheme()
  const bookendWidth = '114px'
  const { scrollY } = useScroll()
  const [scrolled, setScrolled] = useState(false)
  const bgColor = scrolled ? colors.uiWhite : colors.uiPearlExtraLight
  const headerLinks = links || getHeaderLinks({ swap })

  useMotionValueEvent(scrollY, 'change', (pos) => {
    setScrolled(pos > 0)
  })

  return (
    <>
      <span
        id="top"
        className={css`
          display: block;
          width: 100%;
          height: 64px;
          background-color: ${bgColor};
        `}
      />
      <FlexBox
        className={css`
          padding: 0 20px;
          background-color: ${bgColor};
          box-shadow: 0px 1px 1px ${colors.whiteSmoke};
          width: 100%;
          height: 64px;
          position: fixed;
          inset: 0 auto auto 0;
          z-index: 10;
        `}
        alignItems="center"
        justifyContent="space-between"
      >
        <div
          className={css`
            ${mediaQueries.tabletL} {
              display: none;
            }
          `}
        >
          <SideDrawer>
            <div
              className={css`
                padding: 60px 20px;
              `}
            >
              <MLPHeaderLinks links={headerLinks} stacked />
              <MLPDownloadAppCTA
                className={css`
                  margin-top: 28px;
                  width: 100%;
                `}
                text="Get the app"
              />
            </div>
          </SideDrawer>
        </div>
        <AnchorLink href="#top">
          <Logo
            className={css`
              width: ${bookendWidth};
              svg {
                width: 93px;
              }
            `}
          />
        </AnchorLink>
        <MLPHeaderLinks
          links={headerLinks}
          className={css`
            display: none;
            ${mediaQueries.tabletL} {
              display: flex;
            }
          `}
        />
        <MLPDownloadAppCTA
          className={css`
            display: none;
            ${mediaQueries.tabletL} {
              display: block;
              width: ${bookendWidth};
            }
          `}
          buttonStyles={css`
            padding: 0 16px;
          `}
          text="Get the app"
        />
        <span
          className={css`
            display: block;
            width: 20px ${mediaQueries.tabletL} {
              display: none;
            }
          `}
        />
      </FlexBox>
    </>
  )
}
